import React from "react"
import styled from "@emotion/styled"
import { Box } from "theme-ui"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ResourceBox = styled(Box)`
    width: 450px;
    height: auto;
    background: #ffffff;
    margin: 1rem;
    box-shadow: rgba(0, 0, 0, 0.24) 4px 5px 8px;
    border-radius: 2rem;
    padding: 0.5rem 0.5rem 1rem;

    &:hover {
        background: ${(props) => props.theme.colors.light_blue_2};
    }
    &:hover img {
        transform: scale(1.3);
    }

    & a {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
    }

    & .image-circle {
        display: inline-block;
        position: relative;
        width: 200px;
        height: 200px;
        overflow: hidden;
        border-radius: 50%;
        margin-top: 2rem;

        & img {
            width: auto;
            height: 100%;
            transition: transform 0.5s;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[7]}) {
            width: 175px;
            height: 175px;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[6]}) {
            width: 150px;
            height: 150px;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[2]}) {
            width: 125px;
            height: 125px;
        }
    }

    & p {
        margin: 2rem;
        text-align: center;
        margin: 1rem auto;
        color: ${(props) => props.theme.colors.text1};
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            font-size: 14px;
        }
    }
    & h3 {
        font-family: Museo Slab;
        margin: 3rem 0 0.5rem;
    }

    & a:hover {
        text-decoration: none;
    }
    & .resource-content {
        width: 100%;
        padding: 0 0.5rem;
    }
    & .tags {
        background: #e8f8ff;
        color: #28a8e0;
        border-radius: 2rem;
        padding: 0.3rem 0.7rem;
        font-size: 12px;
    }
    & .footer {
        font-size: 12px;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        margin: 1rem;
        flex-direction: column;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        margin: 0.5rem;
        flex-direction: column;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
        margin: 1rem auto;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        height: auto;
        padding-bottom: 1rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        width: 100%;
    }
`

const Cards = ({ summary, title, author, tag, slug, imageFile }) => {
    return (
        <ResourceBox className="resources-card">
            <Link to={slug}>
                <div className="image-circle">
                    <GatsbyImage image={getImage(imageFile)} alt={title} />
                </div>
                {/* <Flex sx={{ flexWrap: "wrap", justifyContent: "center" }}> */}
                <h3>{title}</h3>
                <p className="resource-content">
                    {summary && summary.slice(0, 80)}...
                </p>
                <Box sx={{ marginTop: "auto" }}>
                    <span className="tags">{tag}</span>
                    <p className="footer">By {author}</p>
                </Box>
                {/* </Flex> */}
            </Link>
        </ResourceBox>
    )
}

export default Cards
